import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../api';

// Async action for signup
export const signupUser = createAsyncThunk('auth/signupUser', async (userData, { rejectWithValue }) => {
    try { 
      const response = await apiClient.post('/auth/register', userData);
      return response.data; // Assuming backend returns the new user data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  });

// Async action for login
export const loginUser = createAsyncThunk('auth/login', async (loginData, { rejectWithValue }) => {
  try {
    const response = await apiClient.post('/auth/login', loginData);
    return response.data; // Assuming backend responds with user token and user data
  } catch (error) {   
    return rejectWithValue(error.response.data);
  }
});

// Async action for cerify otp
export const verifyOtp = createAsyncThunk('auth/verify-otp', async (otpData, { rejectWithValue }) => {
  try {
      const response = await apiClient.post('/auth/verify-otp', otpData);
    return response.data; // Assuming backend responds with user token and user data
  } catch (error) {   
    return rejectWithValue(error.response.data);
  }
});

// Async action for forgot password
export const forgotPassword = createAsyncThunk('auth/forgotPassword', async (email, { rejectWithValue }) => {
  try {
    const response = await apiClient.post('/auth/forgot-password', { email });
    return response.data; // return success message
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});
export const resetPassword = createAsyncThunk(
    'auth/resetPassword',
    async ({ token, password }, { rejectWithValue }) => { // Expect a single object as payload  
      try {
        console.log(token,"password");
        
        const response = await apiClient.post('auth/reset-password', { token, password });
        return response.data; // Return success message
      } catch (error) {
        // Handle error and reject with the error response
        return rejectWithValue(error.response.data);
      }
    }
  );
// Initial state
const initialState = {
  status: 'idle',
  user: null,
  universities: [], // Initialize as an empty array
  token: null,
  error: null,
  isLoading: false,
  message: null,
};

// Slice
const loginSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.status = 'idle';
      state.user = null;
      state.token = null;
      localStorage.clear()
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(signupUser.pending, (state) => {
      state.status = 'loading';
    })
    .addCase(signupUser.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.user = action.payload; // Store the signed-up user data
    })
    .addCase(signupUser.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.payload.message; // Capture the error from backend
    });
    // Handle login actions
    builder
      .addCase(loginUser.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // state.user = action.payload.user;
        // state.token = action.payload.token; // Store the received token
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Login failed'; // Capture the error from backend
      });
      //verify otp
      builder
      .addCase(verifyOtp.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload.user;
        state.token = action.payload.token; // Store the received token
        state.error = null;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        console.log(action,"Action");
        
        state.status = 'failed';
        state.error = action.payload.message || 'Login failed'; // Capture the error from backend
      });
      
    // Handle forgot password actions
    builder
      .addCase(forgotPassword.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.message = action.payload.message || 'Password reset email sent';
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message || 'Failed to send reset email';
      });

       // Handle reset password actions
    builder
    .addCase(resetPassword.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase(resetPassword.fulfilled, (state, action) => {
      state.isLoading = false;
      state.message = action.payload.message || 'Password reset email sent';
    })
    .addCase(resetPassword.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.message || 'Failed to send reset email';
    });
  },
});

// Export actions and reducer
export default loginSlice.reducer;
export const { logout } = loginSlice.actions;

